<template>
<div>
  <div class="stepChart">
    <div class="stepChart__item" :data-active="isActive(index)"
      v-for="(step, index) in steps" :key="step.text">
      {{ step.text }}
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'step-chart',
  props: {
    steps: {
      type: Array,
      default: () => ([])
    },
    active: {
      type: Number,
      required: true
    }
  },
  methods: {
    isActive(idx) {
      return this.active === idx + 1
    }
  }
}</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/StepChart.vue